export default "macro new(node)\n  #<loc:{{node.filename}},{{node.line_number}},{{node.column_number}}>{{node}}.new\nend\n\nnew BadType\n";